import React from 'react';
import { createRoot } from 'react-dom/client';

import GlobalStyle from '../common/context/GlobalStyle';
import { LangsContextProvider } from '../common/context/LangsContext';
import langs from './langs';
import LoginForm from './LoginForm';

function Index() {
    return (
        <LangsContextProvider allLangs={langs}>
            <GlobalStyle />
            <LoginForm />
        </LangsContextProvider>
    );
}

window.addEventListener('load', () => {
    const main = document.createElement('div');
    document.body.appendChild(main);
    const root = createRoot(main);
    root.render(<Index />);
});
